// extracted by mini-css-extract-plugin
export default {"Margin":"PageNotFound_Margin__sC4N7"};